import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: 0,
    width: '100%',
    maxWidth: '100%',
    overflowX: 'hidden',
    boxSizing: 'border-box',
  },
  tabs: {
    backgroundColor: "#fff",
    color: "#000",
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0',
    minHeight: '48px',
    overflow: 'hidden',
    '& .MuiTabs-flexContainer': {
      flexWrap: 'nowrap',
      flex: 1,
      justifyContent: 'flex-start',
      display: 'flex',
      gap: '2px',
      minWidth: 0,
    },
  },
  tabsWithActions: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    padding: '0 4px',
    gap: '4px',
    flexWrap: 'nowrap',
    overflow: 'hidden',
    boxSizing: 'border-box',
  },
  tab: {
    minWidth: 'auto',
    padding: '8px 6px',
    textTransform: "none",
    fontWeight: theme.typography.fontWeightRegular,
    marginTop: "8px",
    position: "relative",
    whiteSpace: 'nowrap',
    textAlign: 'center',
    flexShrink: 1,
    fontSize: '0.95rem',
    "&::before": {
      content: '""',
      position: "absolute",
      left: '50%',
      transform: 'translateX(-50%)',
      width: 'calc(100% - 12px)',
      height: "4px",
      top: 0,
      background: "linear-gradient(82deg, #3B173F 0%, #073270 100%)",
    },
    "&.Mui-selected": {
      color: "#34a0f7",
    },
  },
  indicator: {
    display: "none",
  },
  tabsRoot: {
    minHeight: '48px',
  },
  uploadButton: {
    backgroundColor: '#ec6535',
    color: '#fff',
    textTransform: 'none',
    borderRadius: '2rem',
    minWidth: '180px',
    height: '40px',
    padding: '8px 20px',
    '&:hover': {
      backgroundColor: '#000000',
      color: '#fff',
    },
  },
  messagesButton: {
    background: 'linear-gradient(82deg, #3B173F 0%, #073270 100%) 0% 0% no-repeat padding-box',
    color: '#fff',
    textTransform: 'none',
    borderRadius: '4px',
    minWidth: '95px',
    height: '36px',
    padding: '8px 16px',
    fontSize: '0.813rem',
    fontWeight: 500,
    '&:hover': {
      background: 'linear-gradient(82deg, #3B173F 0%, #073270 100%) 0% 0% no-repeat padding-box',
      opacity: 0.9,
      color: '#fff',
    },
  },
  viewButton: {
    backgroundColor: 'transparent',
    color: '#666',
    textTransform: 'none',
    borderRadius: '4px',
    minWidth: '80px',
    height: '36px',
    padding: '8px 12px',
    fontSize: '0.813rem',
    fontWeight: 500,
    border: '1px solid #e0e0e0',
    '&:hover': {
      backgroundColor: '#f5f5f5',
      color: '#000',
      borderColor: '#ccc',
    },
  },
  viewButtonActive: {
    backgroundColor: '#ffffff',
    color: '#000000',
    textTransform: 'none',
    borderRadius: '4px',
    minWidth: '80px',
    height: '36px',
    padding: '8px 12px',
    fontSize: '0.813rem',
    fontWeight: 500,
    border: '1px solid #000000',
    '&:hover': {
      backgroundColor: '#f5f5f5',
      color: '#000000',
      borderColor: '#000000',
    },
  },
  chatIconButton: {
    width: '36px',
    height: '36px',
    borderRadius: '4px',
    backgroundColor: '#ffffff',
    border: '1px solid #000000',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    '& svg': {
      color: '#3B173F',
    },
    '&:hover': {
      backgroundColor: '#f5f5f5',
      borderColor: '#000000',
      '& svg': {
        color: '#3B173F',
      },
    },
  },
  actionButtonsContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    alignItems: 'center',
  },
  headerBar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '4px 0',
    marginBottom: '4px',
  },
}));

